import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
import { connectFirestoreEmulator, initializeFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth, initializeAuth, indexedDBLocalPersistence, connectAuthEmulator,} from '@angular/fire/auth';
import { connectFunctionsEmulator, getFunctions, provideFunctions,} from '@angular/fire/functions';
import { provideStorage, getStorage } from '@angular/fire/storage';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      // Kein navAnimation hier: ion-router-outlet liest die Einstellung nicht.
      // Nachgemessen - der Builder wurde kein einziges Mal aufgerufen. Die
      // Seitenanimation haengt am [animation]-Eingang des Outlets, siehe
      // app.component.html.
      swipeBackEnabled: false
    }),
    AppRoutingModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => {
      /*
       * experimentalAutoDetectLongPolling: Firestore prueft aktiv, ob sein
       * Streaming-Kanal (WebChannel) wirklich traegt, statt in einen Timeout zu
       * laufen.
       *
       * Hintergrund: Ohne diese Einstellung versucht das SDK zuerst WebChannel
       * und merkt erst nach Ablauf einer langen Frist, dass nichts durchkommt -
       * genau in der Groessenordnung der 30 bis 40 Sekunden, die auf dem Handy
       * beobachtet wurden. Stoeren koennen das nicht nur Mobilfunk-Proxys,
       * sondern auch Router, VPNs, Sicherheitssoftware und Browser-
       * Erweiterungen. Haeufiger noch: der Kanal stirbt still, wenn das Geraet
       * schlafen geht, und das Wiederanknuepfen kostet dieselbe Frist.
       *
       * Auf gesunden Verbindungen kostet die Erkennung nichts - sie faellt nur
       * dann auf Long-Polling zurueck, wenn es noetig ist.
       */
      const firestore = initializeFirestore(getApp(), {
        experimentalAutoDetectLongPolling: true,
      });
      // if (environment.useFirebaseEmulator) {
      //   connectFirestoreEmulator(firestore, 'localhost', 8080);
      // }
      return firestore;
    }),
    provideFunctions(() => {
      const functions = getFunctions(undefined, 'europe-west1');
      if (environment.useFirebaseEmulator) {
        connectFunctionsEmulator(functions, 'localhost', 5001);
      }
      return functions;
    }),
    provideStorage(() => getStorage()),
    provideAuth(() => {
      if (Capacitor.isNativePlatform()) {
        return initializeAuth(getApp(), {
          persistence: indexedDBLocalPersistence,
        });
      } else {
        const auth = getAuth();
        // if (environment.useFirebaseEmulator) {
        //   connectAuthEmulator(auth, 'http://localhost:9099');
        // }
        return auth;
      }
    }),
    // provideAppCheck(() => {
    //   return initializeAppCheck(undefined, {
    //   provider: new ReCaptchaV3Provider(environment.reCaptchaKey),
    //   isTokenAutoRefreshEnabled: true,
    // }),

    BrowserAnimationsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
